/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Redirecting_TitleInputs */

const en_auth_redirecting_title = /** @type {(inputs: Auth_Redirecting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting to sign in`)
};

const pt_br2_auth_redirecting_title = /** @type {(inputs: Auth_Redirecting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecionando para login`)
};

/**
* | output |
* | --- |
* | "Redirecting to sign in" |
*
* @param {Auth_Redirecting_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_redirecting_title = /** @type {((inputs?: Auth_Redirecting_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Redirecting_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_redirecting_title(inputs)
	return pt_br2_auth_redirecting_title(inputs)
});